import { date, object, ref, string } from 'yup';

export type IResidentFeedingTubePeriod = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  startDate: Date;
  endDate: Date | null;
  remark: string | null;
};

export type IResidentFeedingTubePeriodCreate = {
  startDate: Date;
  endDate?: Date | null;
  remark?: string | null;
};

export const IResidentFeedingTubePeriodCreateSchema = object({
  startDate: date().required(),
  endDate: date().nullable().optional().min(ref('startDate')).default(null),
  remark: string().nullable().optional(),
});

export type IResidentFeedingTubePeriodUpdate = {
  endDate?: Date | null;
  remark?: string | null;
};

export const IResidentFeedingTubePeriodUpdateSchema = object({
  endDate: date().nullable().optional(),
  remark: string().nullable().optional(),
});
